'use client';

import getLabel from '@/assets/images/status/label-get.png';
import { LOTTERY_STATUS, VARIANT } from '@/constants';
import { isGotGoods } from '@/features/lottery/utils';
import { resolveLanguage } from '@/lib/l18n/function';
import {
  LotteryGoodsList as CommonLotteryGoodsList,
  type LotteryGoodsListProps,
  formatCurrency,
} from '@monorepo/common';
import { useTranslation } from 'react-i18next';

function LotteryGoodsList({
  isGotGoods: isGotGoodsFunc = isGotGoods,
  formatCurrency: formatCurrencyFunc = formatCurrency,
  LOTTERY_STATUS: LOTTERY_STATUS_CONST = LOTTERY_STATUS,
  getLabelSrc = getLabel.src,
  ...props
}: Omit<LotteryGoodsListProps, 'variant' | 'isGotGoods' | 'formatCurrency' | 'LOTTERY_STATUS' | 'getLabelSrc'> & {
  isGotGoods?: LotteryGoodsListProps['isGotGoods'];
  formatCurrency?: LotteryGoodsListProps['formatCurrency'];
  LOTTERY_STATUS?: LotteryGoodsListProps['LOTTERY_STATUS'];
  getLabelSrc?: LotteryGoodsListProps['getLabelSrc'];
}) {
  const { i18n } = useTranslation();
  const locale = resolveLanguage(i18n.resolvedLanguage);

  return (
    <CommonLotteryGoodsList
      variant={VARIANT}
      isGotGoods={isGotGoodsFunc}
      formatCurrency={formatCurrencyFunc}
      LOTTERY_STATUS={LOTTERY_STATUS_CONST}
      getLabelSrc={getLabelSrc}
      locale={locale}
      {...props}
    />
  );
}

export default LotteryGoodsList;
